import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// This component wraps routes that should only be accessible to authenticated users
function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Firebase hasn't resolved the auth state yet — wait rather than
  // bouncing to /login while currentUser is still its initial null.
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div style={{ width: 36, height: 36, border: '3px solid rgba(255,77,46,0.2)', borderTopColor: 'var(--ember)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  // If user is not authenticated, redirect to login.
  // Pass the origin both as router state (fast path) and as a query param
  // (survives a full reload — router state doesn't, and mobile Safari
  // reloads tabs from the URL bar often enough that this matters).
  if (!currentUser) {
    return (
      <Navigate
        to={`/login?from=${encodeURIComponent(location.pathname)}`}
        state={{ from: location }}
        replace
      />
    );
  }

  // If user is authenticated, render the children (protected component)
  return children;
}

export default PrivateRoute;